<button mat-stroked-button class="inverted-stroked-button text-uppercase">
  <ng-content></ng-content>
</button>
